module.exports = __webpack_public_path__ + "img/266.82810797.svg";